/* eslint-disable import/no-unresolved */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AnimateHeight from 'react-animate-height';

import TrashIco from 'images/products/project_quote/trash-ico.svg'
import imgArrowDown from 'images/products/project_quote/arrow-double-down.svg'
import imgArrowUp from 'images/products/project_quote/arrow-double-up.svg'

// eslint-disable-next-line react/prop-types
const Edit = ({ showEdit, onEdit }) => {
  if (!showEdit) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-link bundle-item-action edit-item"
      onClick={() => onEdit()}>
      EDIT
    </button>
  )
}

// eslint-disable-next-line react/prop-types
const Delete = ({ showDelete, onDelete }) => {
  if (!showDelete) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-link px-0 bundle-item-action remove-item"
      onClick={() => onDelete()}>
      <img src={TrashIco} alt="delete" className="trash-ico" />
    </button>
  )
}

const BundleItemTabWrap = ({
  code,
  name,
  subtitle,
  showDelete,
  showSummary,
  showAnimationHeight,
  onDelete,
  children,
  contentClassName,
}) => {
  const initialHeight = showAnimationHeight ? 22 : 'auto';
  const [height, setHeight] = useState(initialHeight)
  const [collapseText, setCollapseText] = useState(false)
  const animate_height_id = `${code}-info-panel`

  const toggleHeight = () => {
    setCollapseText(!collapseText)
    setHeight(height === 22 ? 'auto' : 22)
  }

  return (
    <div className="bundle-item" id={name.replace(' ', '-').toLowerCase()}>
      <div className="bundle-item-head">
        <div className="bundle-item-actions float-end">
          <Delete showDelete={showDelete} onDelete={onDelete} />
        </div>
        <div className="bundle-item-name">
          {name} {showSummary && <span>SUMMARY</span>}
          <div className="d-flex justify-content-start">
            {showAnimationHeight && (
              <div
                className="toggle-icon"
                onClick={toggleHeight}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && toggleHeight()}>
                <img
                  src={collapseText ? imgArrowUp : imgArrowDown}
                  alt="delete"
                  className="delete-ico" />
              </div>
            )}
            <div className="content">
              <AnimateHeight id={animate_height_id} duration={500} height={height}>
                <p className="bundle-item-subtitle">{subtitle}</p>
              </AnimateHeight>
            </div>
          </div>
        </div>
      </div>

      <div className={classNames('bundle-item-content', contentClassName)}>
        {children}
      </div>
    </div>
  )
}

BundleItemTabWrap.defaultProps = {
  onDelete: null,
  children: null,
  contentClassName: {},
  code: '',
}

BundleItemTabWrap.propTypes = {
  code: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  showDelete: PropTypes.bool.isRequired,
  showSummary: PropTypes.bool.isRequired,
  showAnimationHeight: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  children: PropTypes.element,
  // eslint-disable-next-line react/forbid-prop-types
  contentClassName: PropTypes.object,
}

export default BundleItemTabWrap
